import getPageNumberFromQuery from "./getPageNumberFromQuery";

export default state => getPageNumberFromQuery(state.search.query);
